import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { CSVDataService } from '@app/export/CSVDataService';
import { StatisticsService } from '@app/services/Statistics/Statistics.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-membership-flow',
  templateUrl: './membership-flow.component.html',
  styleUrls: ['./membership-flow.component.css']
})
export class MembershipFlowComponent implements OnInit {
form;
  
  result;
  items: MenuItem[];
  showSpinner = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private datePipe: DatePipe,
    private statisticsService: StatisticsService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clearReport();
      }
    });
  }

  ngOnInit() {
    this.form = this.fb.group({
      lodges: ['', ''],
      camps: ['', ''],
      institutions: ['', ''],
      parentInstitutionId: ['', ''],
      selectedFilter: ['', ''],
      selectedYears: ['', ''],
      districts: ['', '']
  
    });
    this.setItems();
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];
  }

  exportToCSV() {
    const firstrow = '';
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'Medlemsflöde_' + datum;
    let data: any[] = [];
    this.result.forEach(x => {
      const row1 = {
        col1: x.result.year,
        col2: x.result.type,
        col3: x.result.shortName + ' ' + x.result.name
      };
      data.push(row1);
      const row2 = {
        col1: 'Antal vid årets början:',
        col2: x.result.membersAtStartOfYear,
        col3: ''
      };
      data.push(row2);
      const row3 = {
        col1: 'Tillkommande',
        col2: '',
        col3: ''
      };
      data.push(row3);
      x.result.incoming.forEach(i => {
        const row = {
          col1: i.institution,
          col2: i.count,
          col3: i.description
        };
        data.push(row);
      });
      const row4 = {
        col1: 'Avgående',
        col2: '',
        col3: ''
      };
      data.push(row4);
      x.result.outgoing.forEach(o => {
        const row = {
          col1: o.institution,
          col2: o.count,
          col3: o.description
        };
        data.push(row);
      });
      const row5 = {
        col1: 'Antal vid årets slut:',
        col2: x.result.membersAtEndOfYear,
        col3: ''
      };
      data.push(row5);
      const emptyrow = {
        col1: '',
        col2: '',
        col3: ''
      };
      data.push(emptyrow);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }

  createReport() {
    this.showSpinner = true;
    var statisticsInput = {
      generalStatisticsReportInputModel: this.form.value
    };
    this.statisticsService.GetMsFlowReport(statisticsInput).subscribe(resp => {
      this.result = resp;

      this.showSpinner = false;
    });
  }

  clearReport() {
    this.result = null;
    this.form?.reset();
  }

}
